import Api from './index'
import { IQuestionResponse } from './types/question'

export const getQuestions = () => Api<IQuestionResponse>('GET', 'support/questions')
